import React, { useState, useEffect } from "react";
import { Row, Col, Typography, Skeleton, Button,Tag } from "antd";
import Card from "./Card";
import styled from "styled-components";
import API_KEY from "api/recommendations";
import DIRECTUS from "api/index";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { useTracking } from "react-tracking";
import {  VIEW_ALL_BUYERS } from "../../analytics/events";
const { Text } = Typography;
const footer =
  "All the information is sourced from publicly available data. Sourcewiz does not take ownership on any of the shipment information";

const RecommendationsCard = styled.div`
  padding: 24px 16px;
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 8px;
  background: linear-gradient(
    159.13deg,
    rgba(232, 240, 252, 0.7) 0%,
    rgba(201, 228, 223, 0.7) 95.49%
  );
`;

const CardTitle = styled(Text)`
  font-size: 16px;
`;

export default function ReccomendationCard() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [prospectIds, setProspectIds] = useState([]);
  const [allProspects, setAllProspects] = useState([]);
  const [savingProspect, setSavingProspect] = useState(false);
  const {trackEvent} = useTracking();
  const pref = JSON.parse(localStorage.getItem("pref"));
  const minFob = pref?.min_fob;
  const maxFob = pref?.max_fob;
  const from = 0;
  const size = 4;
  const hsCodes = pref?.hs_code;

  const fetchBuyers = () => {
    // setLoading(true);
    API_KEY.URL.post(
      `${API_KEY.path.recommend}?min_fob_in_INR=${minFob}&max_fob_in_INR=${maxFob}&from_=${from}&size_=${size}`,
      {
        hscodes: hsCodes,
        facets: {},
      }
    )
      .then((res) => {
        setLoading(false);
        console.log(res?.data?.hits.map((item) => item?._source));
        createSlides(res?.data?.hits.map((item) => item?._source));
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (allProspects && prospectIds) {
      fetchBuyers();
    }
  }, [allProspects, prospectIds]);
  // api call to get buyers
  useEffect(() => {
    setLoading(true);
    DIRECTUS.URL.get(DIRECTUS.path.prospects, {
      params: {
        fields: "importer_id,id",
      },
    })
      .then((res) => {
        setProspectIds(res.data?.data.map((importer) => importer?.importer_id));
        setLoading(false);
        setAllProspects(res.data?.data);

        // setActive(res?.data?.data?.[0]?.id)
        // fetchBuyerData(res?.data?.data?.[0]?.id)
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const fetchProspects = () => {
    DIRECTUS.URL.get(DIRECTUS.path.prospects, {
      params: {
        fields: "importer_id,id",
      },
    })
      .then((res) => {
        setProspectIds(res.data?.data.map((importer) => importer?.importer_id));
        setLoading(false);

        setAllProspects(res.data?.data);
        // fetchBuyers();
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  const handleShortlist = (isShortlisted, { id, country, title }) => {
    if (!isShortlisted) {
      const payload = {
        country: country,
        importer_id: id,
        name: title,
        manufacturer: JSON.parse(localStorage.getItem("org"))?.id,
      };
     
      DIRECTUS.URL.post(DIRECTUS.path.prospects, payload)
        .then((res) => {
          setProspectIds((state) => [...state, `${id}`]);
         
          
        })
        .catch((err) => setSavingProspect(false));
    } else {
      const prospect = allProspects.filter(
        (prospect) => prospect?.importer_id === `${id}`
      )?.[0];
      
      DIRECTUS.URL.delete(`${DIRECTUS.path.prospects}/${prospect?.id}`)
        .then((res) => {
          setProspectIds((state) => state.filter((item) => item !== `${id}`));
          // fetchProspects();
         
        })
        .catch((err) => setSavingProspect(false));
    }
  };

  const createSlides = (data) => {
    setSlides(
      data.map((buyer, index) => {
        return {
          id: index,
          component: (
            <Card
              title={buyer.buyer_name}
              country={buyer.buyer_country}
              str2={buyer?.trading_partners}
              str1={
                typeof buyer?.dealing_cities === "object"
                  ? buyer?.dealing_cities?.[0]
                  : buyer?.dealing_cities
              }
              btnName={
                <Row align="middle" style={{ margin: 0, padding: 0 }}>
                  <Text style={{ color: "#0B7764" }}>View details</Text>{" "}
                  <MdKeyboardArrowRight size={20} />
                </Row>
              }
              onClick={() =>
               { history.push(`/buyer-details/${buyer?.importer_id}`);
                trackEvent({
                  name: VIEW_ALL_BUYERS,
                  meta: {
                    buyer_id: buyer?.importer_id,
                    buyer_name: buyer?.buyer_name,
                  },
                })
              }
              }
              isShortlisted={prospectIds.includes(`${buyer?.importer_id}`)}
              handleShortlist={handleShortlist}
              id={buyer?.importer_id}
              savingProspect={savingProspect}
              showShortlistButton={false}
            />
          ),
        };
      })
    );
  };

  const handleCardClick = (id) => {
    history.push("/buyer-list")
    trackEvent({
      name: VIEW_ALL_BUYERS,
      meta: {
        
      },
    });
  }

  return (
    <RecommendationsCard>
      <Row justify="space-between">
        <CardTitle type="secondary">Recommendations for you</CardTitle>
    <div>
        <Tag color="orange" style={{border:0,borderRadius:4,width:"4em",textAlign:'center'}}>BETA</Tag>
       
    </div>
    

      </Row>
    
    
      <span>
              {loading ? (
                <Skeleton active />
              ) : (
                slides?.[activeSlide]?.["component"]
              )}
            </span>

      {loading ? (
        <Skeleton />
      ) : (
        <Row align="middle" justify="space-between" style={{marginTop:'4em'}}>
          <Col>
            <MdKeyboardArrowLeft
              style={{ cursor: "pointer" }}
              size={35}
              onClick={() =>
                activeSlide > 0
                  ? setActiveSlide((state) => state - 1)
                  : setActiveSlide(3)
              }
              color="#0B7764"
            />
          </Col>
          <Col>
          <Row justify="center" align="middle" >
          {slides.map((item, index) => (
            <span
              key={index}
              className={`dashoard-slide${index === activeSlide ? " active" : ""}`}
              onClick={() => setActiveSlide(index)}
            ></span>
          ))}
        </Row>
          </Col>
          <Col>
            <MdKeyboardArrowRight
              style={{ cursor: "pointer" }}
              color="#0B7764"
              size={35}
              onClick={() =>
                activeSlide < 3
                  ? setActiveSlide((state) => state + 1)
                  : setActiveSlide(0)
              }
            />
          </Col>
        </Row>
      )}

      {/* {loading ? (
        <Skeleton.Button active />
      ) : (
        <Row justify="center" align="middle" style={{ marginTop: "2.5em" }}>
          {slides.map((item, index) => (
            <span
              key={index}
              className={`slide${index === activeSlide ? " active" : ""}`}
              onClick={() => setActiveSlide(index)}
            ></span>
          ))}
        </Row>
      )} */}
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <Row justify="center" style={{ marginTop: "2.5em" }}>
            <Col span={12}>
              <Button
                size="large"
                onClick={() =>handleCardClick()}
                style={{
                  color: "white",
                  background: "#4E5655",
                  width: "100%",
                  border: 0,
                }}
              >
                View all buyers
              </Button>
            </Col>
          </Row>
          <Row justify="center" style={{ marginTop: "1em" }}>
            <a href="https://www.youtube.com/watch?v=CH2h_lCPkns">
              {" "}
              Learn more
            </a>
          </Row>
        </>
      )}

      {loading ? (
        <Skeleton active />
      ) : (
        <Row
          justify="center"
          style={{ marginTop: "2.5em", textAlign: "center" }}
        >
          <Col>
            <Text type="secondary">{footer}</Text>
          </Col>
        </Row>
      )}
    </RecommendationsCard>
  );
}
